/*
Example state:

export default {
  byId: {
    ans1: {
      id: 'ans1',
      name: 'Can you guess who is NOT cool?',
      content: {
        public: {
          bodyHtml: 'Jdom is not cool.',
        },
      },
    },
    ans2: {
      id: 'ans2',
      name: 'Can you guess who IS cool?',
      content: {
        public: {
          bodyHtml: 'Kaylee is cool.',
        },
      },
    },
  },
  allIds: ['ans1', 'ans2'],
  suggestedAnswerIds: ['ans1', 'ans2'],
  searchResultAnswerIds: ['ans1', 'ans2'],
  selectedResultAnswerId: '',
};

*/

export default {
  byId: {},
  allIds: [],
  suggestedAnswerIds: [],
  searchResultAnswerIds: [],
  selectedResultAnswerId: '',
};
